import React from 'react'

const Rombo = props => (
  <svg xmlns="http://www.w3.org/2000/svg" stroke="#000" viewBox="0 0 50 50">
    <line
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={4}
      x1="25"
      y1="3"
      x2="42"
      y2="25"
    />
    <line
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={4}
      x1="42"
      y1="25"
      x2="25"
      y2="47"
    />
    <line
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={4}
      x1="25"
      y1="47"
      x2="7"
      y2="25"
    />
    <line
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={4}
      x1="7"
      y1="25"
      x2="25"
      y2="3"
    />
  </svg>
)

export default Rombo



// WEBPACK FOOTER //
// ./src/components/svgs/rombo/index.js